export default {
  methods: {
    selectAll (event, partialList, fullList, valueMethod = "id") {
      if (event === "All") {
        this[partialList] = this[fullList].map(e => e[valueMethod]);
      } else {
        this[partialList] = [];
      }
    }
  }
};
